module.exports = __webpack_public_path__ + "img/cup.5a1bfc35.png";